exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.variation-wrapper[data-v-465869d0] {\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -5px;\n  margin-right: -5px;\n  margin-top: .5em;\n}\n", ""]);

// exports
